import { render, staticRenderFns } from "./PhaseToPhase.UK.2.vue?vue&type=template&id=4e3e734a&scoped=true"
import script from "./PhaseToPhase.UK.2.vue?vue&type=script&lang=js"
export * from "./PhaseToPhase.UK.2.vue?vue&type=script&lang=js"
import style0 from "./PhaseToPhase.UK.2.vue?vue&type=style&index=0&id=4e3e734a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3e734a",
  null
  
)

export default component.exports